import script from "./ReviewDashboardView.vue?vue&type=script&setup=true&lang=js"
export * from "./ReviewDashboardView.vue?vue&type=script&setup=true&lang=js"

import "./ReviewDashboardView.vue?vue&type=style&index=0&id=e31f2e9e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e31f2e9e"]])

export default __exports__